export { default } from './StructuredLyrics';
